import ky from 'ky-universal';
import localforage from 'localforage';

export default class betting {

    constructor() {
        this.api = ky.create({ prefixUrl: 'https://httpbin.org/' });

        this.store = localforage.createInstance({
            driver: localforage.LOCALSTORAGE,
            name: 'sportify',
            version: 1.0,
            storeName: 'auth',
            description: 'sportify auth'
        });
    }
}